import { $_GET } from './commonH5'
import Vue from "vue";
let ua = navigator.userAgent;
let platform = navigator.platform;
var os = {},
	browser = {},
	webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
	android = ua.match(/(Android);?[\s\/]+([\d.]+)?/),
	osx = !!ua.match(/\(Macintosh\; Intel /),
	ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
	ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
	iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
	webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
	win = /Win\d{2}|Windows/.test(platform),
	wp = ua.match(/Windows Phone ([\d.]+)/),
	touchpad = webos && ua.match(/TouchPad/),
	kindle = ua.match(/Kindle\/([\d.]+)/),
	silk = ua.match(/Silk\/([\d._]+)/),
	blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
	bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
	rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
	playbook = ua.match(/PlayBook/),
	chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
	firefox = ua.match(/Firefox\/([\d.]+)/),
	firefoxos = ua.match(/\((?:Mobile|Tablet); rv:([\d.]+)\).*Firefox\/[\d.]+/),
	ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
	webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
	safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/),
	weixin = ua.match(/MicroMessenger/i),
	dd = $_GET['user_client'] === 'iphone' || $_GET['ct'] === 'iphone' || $_GET['user_client'] === 'android' || $_GET['ct'] === 'android' ||ua.match(/dangdang-/i),
	quickapp = $_GET['user_client'] === 'huawei' || $_GET['ct'] === 'huawei' || ua.match(/hap\//i),
	swan = $_GET['user_client'] === 'swan' || $_GET['ct'] === 'swan' || ua.match(/swan/i),
	alipay = $_GET['user_client'] === 'alipay' || $_GET['ct'] === 'alipay' || ua.match(/AlipayClient/i),
  qq = $_GET['user_client'] === 'qqminiapp' || $_GET['ct'] === 'qqminiapp' || ua.match(/QQ/i) && ua.match(/miniProgram/i) // QQ小程序

// Todo: clean this up with a better OS/browser seperation:
// - discern (more) between multiple browsers on android
// - decide if kindle fire in silk mode is android or not
// - Firefox on Android doesn't specify the Android version
// - possibly devide in os, device and browser hashes

if ((browser.webkit = !!webkit)) browser.version = webkit[1];

if (android) (os.android = true), (os.version = android[2]);
if (iphone && !ipod) (os.ios = os.iphone = true), (os.version = iphone[2].replace(/_/g, "."));
if (ipad) (os.ios = os.ipad = true), (os.version = ipad[2].replace(/_/g, "."));
if (ipod) (os.ios = os.ipod = true), (os.version = ipod[3] ? ipod[3].replace(/_/g, ".") : null);
if (wp) (os.wp = true), (os.version = wp[1]);
if (webos) (os.webos = true), (os.version = webos[2]);
if (touchpad) os.touchpad = true;
if (blackberry) (os.blackberry = true), (os.version = blackberry[2]);
if (bb10) (os.bb10 = true), (os.version = bb10[2]);
if (rimtabletos) (os.rimtabletos = true), (os.version = rimtabletos[2]);
if (playbook) browser.playbook = true;
else browser.playbook = false;
if (kindle) (os.kindle = true), (os.version = kindle[1]);
if (silk) (browser.silk = true), (browser.version = silk[1]);
else browser.silk = false;
if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
else browser.silk = false;
if (chrome) (browser.chrome = true), (browser.version = chrome[1]);
else browser.chrome = false;
if (firefox) (browser.firefox = true), (browser.version = firefox[1]);
else browser.firefox = false;
if (firefoxos) (os.firefoxos = true), (os.version = firefoxos[1]);
else os.firefoxos = false;
if (ie) (browser.ie = true), (browser.version = ie[1]);
else browser.ie = false;
if (safari && (osx || os.ios || win)) {
	browser.safari = true;
	if (!os.ios) browser.version = safari[1];
} else browser.safari = false;
if (webview) browser.webview = true;
else browser.webview = false;

os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) || (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 || (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) || (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));

if (weixin) browser.weixin = true; //微信里
else browser.weixin = false;
if (dd) browser.dd = true; //当当app
else browser.dd = false;
if (weixin && ua.match(/miniProgram/i)) browser.mina = true; //微信小程序
else browser.mina = false;
if (quickapp) browser.quickapp = true;
else browser.quickapp = false;
if (swan) browser.swan = true;
else browser.swan = false;
if (alipay) browser.alipay = true;
else browser.alipay = false;
if (qq) browser.qq = true;
else browser.qq = false;

if (browser.dd || browser.mina || browser.quickapp || browser.swan || browser.qq || browser.alipay) {
	//嵌入专题页的端: app 微信小程序 百度小程序 快应用 QQ 支付宝小程序
	browser.inset = true;
} else {
	browser.inset = false;
}

if (os.android) {
	// addjs("//statres.quickapp.cn/quickapp/js/routerinline.min.js");
	//华为单独的文件
	// addjs("//appimg.dbankcdn.com/hwmarket/files/fastapp/router.fastapp.js");
}
// 当当客户端
if (browser.dd) {
	addjs("//staticobs.ddimg.cn/try/bridge-1.0.8.min.js", () => {
    // iphone右滑返回前一页与iscroll吸顶导航滑动功能冲突，禁用原生的
    // http://wiki.dangdang.cn/display/qtyf/JSBridge
    if (appBridge && appBridge.callSlidePop) {
      try {
        appBridge.callSlidePop({ slideEnable: '0' })
      } catch (e) {
        console.error('jsbridge设置出错', e)
      }
    }
  });
}
//百度小程序
if (browser.swan) {
	addjs("//b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.21.js");
}
//微信
if (browser.weixin) {
	console.log('--browser.weixin-',)
	addjs("//res.wx.qq.com/open/js/jweixin-1.6.0.js",()=>{
		console.log('wx-sdk执行完毕-isResolve',Vue.prototype.$isResolve)
		Vue.prototype.$isResolve()
	});
}
//支付宝小程序
if (browser.alipay) {
	addjs("https://appx/web-view.min.js");
}
//手机百度
if (ua.indexOf("baiduboxapp") > -1) {
    addjs("//b.bdstatic.com/searchbox/icms/searchbox/js/boxjs-1.0.2.js");
}
// QQ小程序
if (browser.qq) {
  addjs('//qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js')
}
/**
 * 增加js文件
 * @param {*} url
 */
function addjs(url, cb = '') {
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.src = url;
  if (typeof cb === 'function') {
    script.onload = script.onreadystatechange = () => {
      cb()
      script.onload = script.onreadystatechange = null
    }
  }
	document.querySelector("body").appendChild(script);
}

export { os, browser };
